import { NativeWindStyleSheet } from "nativewind";
import { Provider as PaperProvider } from "react-native-paper";
import settings from "../../../settings";
import theme, { colors } from "../../../theme";

import { createTheme, ThemeProvider as MuiProvider } from "@mui/material/styles";
import React, { ReactNode } from "react";
import screens from "../../../theme/screens";

NativeWindStyleSheet.setOutput({
  default: "native",
});

const muiTheme = createTheme({
  palette: {
    primary: {
      main: colors.primary.DEFAULT,
    },
    secondary: {
      main: colors.secondary.DEFAULT,
    },
    error: {
      main: colors.red.darkest,
    },
  },
  breakpoints: {
    // match tailwind breakpoints
    values: {
      xs: 0,
      ...screens,
    },
  },
});

const HoverStyles = () => {
  // generic hover effect https://thisdevbrain.com/generic-css-hover-effect/
  return (
    <style type="text/css">
      {`
      *[role='button']:not(.MuiSelect-select)::before {
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        opacity: 0;
        content: " ";
      }

      *[role='button']:not(.MuiSelect-select):hover::before {
        background-color: currentColor;
        opacity: 0.1;
      }

      a:hover {
        text-decoration: underline;
        text-decoration-color: ${colors.ink.darkest};
      }

      textarea:focus, input:focus{
        outline: none;
      }
    `}
    </style>
  );
};

export default function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <PaperProvider {...{ theme, settings }}>
      <>
        <HoverStyles />
        <MuiProvider theme={muiTheme}>{children}</MuiProvider>
      </>
    </PaperProvider>
  );
}
